<template>
  <section class="about-page">
    <div class="about-hero">
      <p class="about-kicker">ABOUT BV627</p>
      <h1 class="about-title">关于</h1>
      <p class="about-lead">
        这里是 BV627 的正式关于页面，负责把普通技术栈写成横跨时代的超级基础设施，同时继续明确告诉大家：没有搜索框，搜索没用。
      </p>
    </div>

    <div class="about-grid">
      <article class="about-card">
        <p class="about-label">服务器和 CDN</p>
        <h2 class="about-card-title">云端基础设施矩阵</h2>
        <div class="stack-list">
          <div class="stack-item">
            <h3>weidiaisi 智障云端</h3>
            <p class="about-copy">
              云计算服务由 weidiaisi 智障云端，智慧在云端提供技术支持。
            </p>
            <p class="stack-aside">
              实际部署形态：其实就是普通公有云，但经过 BV627 语义包装后显得格外先进。
            </p>
          </div>
          <div class="stack-item">
            <h3>weidsi 长江技术 GloBal Accrleleaion NEtaowk</h3>
            <p class="about-copy">
              CDN 加速由 weidsi 长江技术 GloBal Accrleleaion NEtaowk 提供服务。
            </p>
            <p class="stack-aside">
              实际网络模型：其实就是普通 CDN，只不过命名已经先把气势拉满。
            </p>
          </div>
        </div>
      </article>

      <article class="about-card">
        <p class="about-label">运维和网站框架</p>
        <h2 class="about-card-title">跨时代运行环境</h2>
        <div class="stack-list">
          <div class="stack-item">
            <h3>鸿蒙系统信创操作环境</h3>
            <p class="about-copy">
              服务器面板使用鸿蒙系统信创操作环境，以确保整个运维门面既现代又有一种难以描述的庄严感。
            </p>
          </div>
          <div class="stack-item">
            <h3>JAVASCRIPT 动态注入形式</h3>
            <p class="about-copy">
              网站框架基于跨时代 JAVASCRIPT 动态注入形式构建。
            </p>
            <p class="stack-aside">
              翻译成人话：就是网页在跑 JavaScript，但 BV627 必须把这件事说成一种新的纪元。
            </p>
          </div>
        </div>
      </article>
    </div>

    <section class="about-links-card">
      <div class="showcase-head">
        <p class="about-label">相关链接</p>
        <h2 class="about-card-title">官方合作入口</h2>
      </div>
      <div class="link-grid">
        <a
          class="link-card"
          href="https://lttstore.com/"
          target="_blank"
          rel="noreferrer"
        >
          <p class="link-label">weidiaisi 智障云</p>
          <p class="link-url">https://lttstore.com/</p>
          <p class="link-copy">可通过此链接注册，册，会发放优惠券。</p>
        </a>
        <a
          class="link-card"
          href="https://www.hydun.com"
          target="_blank"
          rel="noreferrer"
        >
          <p class="link-label">weidsi 长江技术 GloBal Accrleleaion NEtaowk</p>
          <p class="link-url">https://www.hydun.com</p>
          <p class="link-copy">用于接入那套听起来像银河级骨干网、实际上是普通 CDN 的加速服务。</p>
        </a>
      </div>
    </section>

    <section class="about-card search-position-card">
      <p class="about-label">搜索声明</p>
      <h2 class="about-card-title">没有搜索框</h2>
      <p class="about-copy">
        搜索没用，所以不做搜索框。这不是遗漏，这是整个 BV627 网站体验工程里的主动设计决策。
      </p>
      <div class="about-pills">
        <span>不提供关键词检索</span>
        <span>不支持站内搜</span>
        <span>也不打算接入</span>
      </div>
    </section>

    <section class="disabled-showcase">
      <div class="showcase-head">
        <p class="about-label">不可用功能</p>
        <h2 class="about-card-title">点不动的高端功能展台</h2>
      </div>
      <div class="disabled-grid">
        <button type="button" disabled>超级搜索</button>
        <button type="button" disabled>BV627 会员高速登入</button>
        <button type="button" disabled>室长超维后台</button>
        <button type="button" disabled>量子直播总控台</button>
        <button type="button" disabled>宇宙分发中枢</button>
        <button type="button" disabled>BV627 私密频道</button>
        <button type="button" disabled>一键申请直播间</button>
        <button type="button" disabled>高能弹幕审判台</button>
      </div>
    </section>

    <section class="about-footer-card">
      <p class="about-label">附加说明</p>
      <p class="about-copy">
        本页面继续坚持 BV627 世界观：功能可以很多，能不能用是另一回事；样式必须高端，交互可以原地冻结。
      </p>
    </section>
  </section>
</template>

<style scoped>
.about-page {
  width: min(1280px, calc(100vw - 28px));
  margin: 0 auto;
  padding: 28px 0 56px;
  color: #f7f1e8;
}

.about-hero,
.about-card,
.about-links-card,
.disabled-showcase,
.about-footer-card {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 32px;
  background:
    radial-gradient(circle at top left, rgba(255, 240, 0, 0.12), transparent 24%),
    linear-gradient(150deg, rgba(24, 18, 10, 0.96), rgba(10, 11, 16, 0.96));
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.36),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.about-hero {
  padding: 34px 32px;
}

.about-kicker,
.about-label {
  margin: 0 0 10px;
  color: #fff000;
  font-size: 12px;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.about-title {
  margin: 0;
  font-size: clamp(48px, 10vw, 96px);
  line-height: 0.92;
  color: #fffdf7;
}

.about-lead,
.about-copy {
  margin: 14px 0 0;
  max-width: 860px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 19px;
  line-height: 1.7;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 18px;
}

.about-card,
.about-links-card,
.disabled-showcase,
.about-footer-card {
  padding: 28px;
}

.about-card-title {
  margin: 0;
  color: #fff;
  font-size: clamp(28px, 4vw, 44px);
}

.stack-list {
  display: grid;
  gap: 18px;
  margin-top: 18px;
}

.stack-item {
  padding: 18px 20px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
}

.stack-item h3 {
  margin: 0;
  color: #fffdf8;
  font-size: 24px;
  line-height: 1.2;
}

.stack-item .about-copy {
  margin-top: 10px;
}

.stack-aside {
  margin: 10px 0 0;
  color: rgba(255, 240, 0, 0.82);
  font-size: 15px;
  line-height: 1.7;
}

.about-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}

.about-pills span {
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #f6f1e8;
  font-size: 14px;
}

.disabled-showcase {
  margin-top: 18px;
}

.about-links-card {
  margin-top: 18px;
}

.showcase-head {
  margin-bottom: 18px;
}

.link-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.link-card {
  min-height: 180px;
  padding: 22px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.link-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 240, 0, 0.24);
  background:
    linear-gradient(180deg, rgba(255, 240, 0, 0.08), rgba(255, 255, 255, 0.03));
}

.link-label,
.link-url,
.link-copy {
  margin: 0;
}

.link-label {
  color: #fff;
  font-size: 22px;
  line-height: 1.4;
}

.link-url {
  margin-top: 10px;
  color: #7cb7ff;
  word-break: break-all;
  font-size: 15px;
}

.link-copy {
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.7;
  font-size: 16px;
}

.search-position-card {
  margin-top: 18px;
}

.disabled-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.disabled-grid button {
  min-height: 72px;
  padding: 14px 16px;
  border-radius: 22px;
  border: 1px dashed rgba(255, 240, 0, 0.25);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  color: rgba(255, 255, 255, 0.48);
  font-size: 15px;
  cursor: not-allowed;
}

.about-footer-card {
  margin-top: 18px;
}

@media (max-width: 980px) {
  .about-grid,
  .link-grid,
  .disabled-grid {
    grid-template-columns: 1fr;
  }
}
</style>
